import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
    background: var(--darkGrey, #1c1c1c);
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* Center content with same max-width as the rest of the header */
    padding: 45px 20px;
    max-width: var(--maxWidth);
    margin: 0 auto;
    position: relative;
    z-index: 100;
    gap: 16px;
`;

export const NavLink = styled(Link)`
    color: #808080;
    display: flex;
    text-align: center;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    white-space: nowrap;
    &.active {
        color: #fe88f1;
    }
    @media screen and (max-width: 768px) {
        padding: 14px 24px;
        width: 100%;
        height: auto;
        border-bottom: 1px solid rgba(255,255,255,0.05);
        &:last-child { border-bottom: none; }
    }
`;

/* Hamburger icon — shown only on mobile, positioned right so it never sits on the logo */
export const Bars = styled.div`
    display: none;
    color: #808080;
    font-size: 1.8rem;
    cursor: pointer;
    flex-shrink: 0;
    /* Push it to the far right without absolute positioning so it doesn't overlap */
    margin-left: 10%;
    @media screen and (max-width: 768px) {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const NavMenu = styled.div`
    display: flex;
    align-items: center;
    /* Use flex-grow so menu fills the space between logo and sign-in button */
    flex: 1;
    justify-content: flex-start;
    margin-left: 8px;
    @media screen and (max-width: 768px) {
        display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
        flex-direction: column;
        align-items: flex-start;
        position: absolute;
        top: 50px;          /* exactly below the nav bar */
        left: 0;
        right: 0;
        background: var(--darkGrey, #1c1c1c);
        z-index: 99;
        padding: 8px 0;
        border-top: 1px solid rgba(255,255,255,0.08);
        box-shadow: 0 8px 24px rgba(0,0,0,0.4);
    }
`;

export const NavBtn = styled.nav`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    @media screen and (max-width: 768px) {
        display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
        margin: 8px 24px 16px;
        position: absolute;
        top: ${({ isOpen, itemCount }) => `${50 + (itemCount || 5) * 50}px`};
        left: 0;
        right: 0;
        background: var(--darkGrey, #1c1c1c);
        padding-bottom: 8px;
        z-index: 99;
    }
`;

export const NavBtnLink = styled(Link)`
    border-radius: 4px;
    background: #808080;
    padding: 10px 22px;
    color: #000000;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    white-space: nowrap;
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #fff;
        color: #808080;
    }
    @media screen and (max-width: 768px) {
        margin-left: 24px;
    }
`;
